// // import React, { useEffect, useState } from "react";
// // import {
// //   collection,
// //   query,
// //   onSnapshot,
// //   updateDoc,
// //   doc,
// // } from "firebase/firestore";
// // import { db } from "../../firebase";
// // import css from "./adm.module.css";
// // import {
// //   getStorage,
// //   ref,
// //   uploadBytesResumable,
// //   getDownloadURL,
// // } from "firebase/storage";
// // import BusinessInvoicesAdmin from "./users/BusinessInvoicesAdmin";
// // import { setPaymentMethod } from "../../services/invoicesService";

// // const UserList = () => {
// //   const [users, setUsers] = useState([]);
// //   const [editedUser, setEditedUser] = useState(null);
// //   const [selectedCategory, setSelectedCategory] = useState("");
// //   const storage = getStorage();

// //   useEffect(() => {
// //     const unsubscribe = onSnapshot(collection(db, "users"), (snapshot) => {
// //       const userList = [];
// //       snapshot.forEach((doc) => {
// //         userList.push({ id: doc.id, ...doc.data() });
// //       });
// //       setUsers(userList);
// //     });
// //     return () => unsubscribe();
// //   }, []);

// //   const handleDoubleClick = (user) => {
// //     setEditedUser(user);
// //   };

// //   const handleInputChange = (e) => {
// //     setEditedUser((prevState) => ({
// //       ...prevState,
// //       [e.target.name]: e.target.value,
// //     }));
// //   };

// //   const handleInputBlur = async (id) => {
// //     try {
// //       await updateDoc(doc(db, "users", id), editedUser);
// //       setEditedUser(null);
// //     } catch (error) {
// //       console.log("Помилка при оновленні документа: ", error);
// //     }
// //   };

// //   const handleCategoryChange = (e) => {
// //     setSelectedCategory(e.target.value);
// //   };

// //   const handlePdfUpload = async (id, file) => {
// //     try {
// //       const storageRef = ref(storage, `pdf/${id}/${file.name}`); // Отримати посилання на потрібну папку у Storage
// //       const uploadTask = uploadBytesResumable(storageRef, file); // Завантажити файл до Storage

// //       uploadTask.on(
// //         "state_changed",
// //         (snapshot) => {
// //           const progress =
// //             (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
// //           console.log("Progress:", progress);
// //         },
// //         (error) => {
// //           console.log("Error uploading file:", error);
// //         },
// //         async () => {
// //           const downloadUrl = await getDownloadURL(uploadTask.snapshot.ref); // Отримати посилання на завантажений файл
// //           await updateDoc(doc(db, "users", id), { pdfAct: downloadUrl }); // Оновити поле pdfAct у документі
// //         }
// //       );
// //     } catch (error) {
// //       console.log("Помилка при завантаженні PDF-файлу: ", error);
// //     }
// //   };

// //   const filteredUsers = selectedCategory
// //     ? users.filter((user) => user.category === selectedCategory)
// //     : users;

// //   return (
// //     <div>
// //       <section>
// //         <label>Оберіть категорію: </label>
// //         <select
// //           name="category"
// //           value={selectedCategory}
// //           onChange={handleCategoryChange}
// //         >
// //           <option value="">Всі</option>
// //           <option value="Читач">Читач</option>
// //           <option value='Член "Клубу Майстрів"'>Член "Клубу Майстрів"</option>
// //           <option value="Бізнес-партнер">Бізнес-партнер</option>
// //           <option value="Майстер">Майстер</option>
// //         </select>
// //       </section>
// //       <ul className={css.userListWrapUL}>
// //         {filteredUsers.map((user) => {
// //           const isEditing = editedUser && editedUser.id === user.id;
// //           return (
// //             <li key={user.id} className={css.userListWrapLi}>
// //               <p
// //                 onDoubleClick={() => handleDoubleClick(user)}
// //                 className={css.userListWrapP}
// //               >
// //                 {isEditing ? (
// //                   <input
// //                     type="text"
// //                     name="displayName"
// //                     value={editedUser.displayName}
// //                     onChange={handleInputChange}
// //                     onBlur={() => handleInputBlur(user.id)}
// //                   />
// //                 ) : (
// //                   <>
// //                     <span>Ім'я: </span>
// //                     {user.displayName}
// //                   </>
// //                 )}
// //               </p>
// //               <p
// //                 onDoubleClick={() => handleDoubleClick(user)}
// //                 className={css.userListWrapP}
// //               >
// //                 {isEditing ? (
// //                   <input
// //                     type="text"
// //                     name="email"
// //                     value={editedUser.email}
// //                     onChange={handleInputChange}
// //                     onBlur={() => handleInputBlur(user.id)}
// //                   />
// //                 ) : (
// //                   <>
// //                     <span>Email: </span>
// //                     {user.email}
// //                   </>
// //                 )}
// //               </p>
// //               <p
// //                 onDoubleClick={() => handleDoubleClick(user)}
// //                 className={css.userListWrapP}
// //               >
// //                 {isEditing ? (
// //                   <input
// //                     type="text"
// //                     name="phone"
// //                     value={editedUser.phone}
// //                     onChange={handleInputChange}
// //                     onBlur={() => handleInputBlur(user.id)}
// //                   />
// //                 ) : (
// //                   <>
// //                     <span>Телефон: </span>
// //                     {user.phone}
// //                   </>
// //                 )}
// //               </p>
// //               <section className={css.userListWrapP}>
// //                 <label>Роль: </label>
// //                 {isEditing ? (
// //                   <select
// //                     name="category"
// //                     value={editedUser.category}
// //                     onChange={handleInputChange}
// //                     onBlur={() => handleInputBlur(user.id)}
// //                   >
// //                     <option value="Читач">Читач</option>
// //                     <option value='Член "Клубу Майстрів"'>
// //                       Член "Клубу Майстрів"
// //                     </option>
// //                     <option value="Бібліотекар">Бібліотекар</option>
// //                     <option value="Дропшипінг">Дропшипінг</option>
// //                     <option value="Гурт-закупка">Гурт-закупка</option>
// //                     <option value="Бізнес-партнер">Бізнес-партнер</option>
// //                   </select>
// //                 ) : (
// //                   <p
// //                     onDoubleClick={() => handleDoubleClick(user)}
// //                     className={css.userListWrapP}
// //                   >
// //                     {user.category}
// //                   </p>
// //                 )}
// //               </section>
// //               <section className={css.userListWrapP}>
// //                 <label>Спосіб оплати: </label>
// //                 <select
// //                   name="paymentMethod"
// //                   value={
// //                     isEditing
// //                       ? editedUser.paymentMethod ?? "card"
// //                       : user.paymentMethod ?? "card"
// //                   }
// //                   onChange={async (e) => {
// //                     // локально для редагування
// //                     if (isEditing) {
// //                       setEditedUser((prev) => ({
// //                         ...prev,
// //                         paymentMethod: e.target.value,
// //                       }));
// //                     } else {
// //                       // миттєво для не-редагованого рядка
// //                       await setPaymentMethod(user.id, e.target.value);
// //                     }
// //                   }}
// //                   onBlur={async () => {
// //                     if (isEditing) {
// //                       await setPaymentMethod(
// //                         user.id,
// //                         editedUser.paymentMethod ?? "card"
// //                       );
// //                       setEditedUser(null);
// //                     }
// //                   }}
// //                 >
// //                   <option value="card">Карткою (за замовчуванням)</option>
// //                   <option value="invoice">Рахунок ТОВ</option>
// //                 </select>
// //               </section>
// //               // ПАНЕЛЬ РАХУНКІВ — показуємо лише для бізнес-партнера:
// //               {user.category === "Бізнес-партнер" &&
// //                 (isEditing
// //                   ? editedUser.paymentMethod ?? "card"
// //                   : user.paymentMethod ?? "card") === "invoice" && (
// //                   <div style={{ marginTop: 8 }}>
// //                     <BusinessInvoicesAdmin uid={user.id} />
// //                   </div>
// //                 )}
// //               <p
// //                 onDoubleClick={() => handleDoubleClick(user)}
// //                 className={css.userListWrapP}
// //               >
// //                 {isEditing ? (
// //                   <input
// //                     type="text"
// //                     name="discount"
// //                     value={editedUser.discount}
// //                     onChange={handleInputChange}
// //                     onBlur={() => handleInputBlur(user.id)}
// //                   />
// //                 ) : (
// //                   <>
// //                     <span>Знижка: </span>
// //                     {user.discount}
// //                   </>
// //                 )}
// //               </p>
// //               <p
// //                 onDoubleClick={() => handleDoubleClick(user)}
// //                 className={css.userListWrapP}
// //               >
// //                 {isEditing ? (
// //                   <input
// //                     type="text"
// //                     name="elefant"
// //                     value={editedUser.elefant}
// //                     onChange={handleInputChange}
// //                     onBlur={() => handleInputBlur(user.id)}
// //                   />
// //                 ) : (
// //                   <>
// //                     <span>Слони: </span>
// //                     {user.elefant}
// //                   </>
// //                 )}
// //               </p>
// //               {user.category === "Бізнес-партнер" && (
// //                 <p>
// //                   <span>Посилання на PDF: </span>
// //                   {isEditing ? (
// //                     <input
// //                       type="file"
// //                       accept=".pdf"
// //                       onChange={(e) =>
// //                         handlePdfUpload(user.id, e.target.files[0])
// //                       }
// //                     />
// //                   ) : (
// //                     <>
// //                       <input
// //                         type="file"
// //                         accept=".pdf"
// //                         onChange={(e) =>
// //                           handlePdfUpload(user.id, e.target.files[0])
// //                         }
// //                       />
// //                     </>
// //                   )}
// //                 </p>
// //               )}
// //             </li>
// //           );
// //         })}
// //       </ul>
// //     </div>
// //   );
// // };

// // export default UserList;
// import React, { useEffect, useState } from "react";
// import { collection, onSnapshot, updateDoc, doc } from "firebase/firestore";
// import { db } from "../../firebase";
// import css from "./uthorListEditor.module.css";
// import { deleteField } from "firebase/firestore";
// import {
//   getStorage,
//   ref as sRef,
//   uploadBytes,
//   getDownloadURL,
//   deleteObject,
// } from "firebase/storage";
// import BusinessInvoicesAdmin from "./users/BusinessInvoicesAdmin";
// import { setPaymentMethod } from "../../services/invoicesService";
// export const ROLES = {
//   CLUB: "Член клубу Майстрів",
//   LIBRARIAN: "Бібліотекар",
//   BUSINESS: "Бізнес-партнер",
//   MASTER: "Майстер",
// };
// const UserList = () => {
//   const [users, setUsers] = useState([]);
//   const [editedUser, setEditedUser] = useState(null);
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [openInvoicesFor, setOpenInvoicesFor] = useState(null); // хто відкрив панель рахунків
//   const [actUploadingFor, setActUploadingFor] = useState(null);

//   const uploadPdfActForUser = async (user, file) => {
//     if (!file) return;

//     // прості валідації
//     if (file.type !== "application/pdf") {
//       alert("Будь ласка, завантаж PDF файл.");
//       return;
//     }
//     if (file.size > 20 * 1024 * 1024) {
//       alert("Файл завеликий. Максимум 20MB.");
//       return;
//     }

//     setActUploadingFor(user.id);

//     try {
//       const storage = getStorage();

//       // 1) видаляємо попередній акт (якщо був), щоб акт завжди був один
//       if (user.pdfActPath) {
//         try {
//           await deleteObject(sRef(storage, user.pdfActPath));
//         } catch (e) {
//           console.warn("Не вдалося видалити попередній акт:", e);
//         }
//       }

//       // 2) заливаємо новий файл в Storage
//       const safeName = (file.name || "act.pdf").replace(/[^\w.\-]+/g, "_");
//       const path = `users/${user.id}/pdfAct/${Date.now()}_${safeName}`;
//       const fileRef = sRef(storage, path);

//       await uploadBytes(fileRef, file, { contentType: "application/pdf" });
//       const url = await getDownloadURL(fileRef);

//       // 3) записуємо URL + path в users/{uid}
//       await updateDoc(doc(db, "users", user.id), {
//         pdfAct: url,
//         pdfActPath: path,
//         pdfActUpdatedAt: Date.now(),
//       });
//     } catch (e) {
//       console.error(e);
//       alert("Не вдалося завантажити акт. Перевір доступ до Storage.");
//     } finally {
//       setActUploadingFor(null);
//     }
//   };

//   const removePdfActForUser = async (user) => {
//     const ok = window.confirm("Видалити акт звірки?");
//     if (!ok) return;

//     try {
//       const storage = getStorage();

//       if (user.pdfActPath) {
//         try {
//           await deleteObject(sRef(storage, user.pdfActPath));
//         } catch (e) {
//           console.warn("Не вдалося видалити файл у Storage:", e);
//         }
//       }

//       await updateDoc(doc(db, "users", user.id), {
//         pdfAct: deleteField(),
//         pdfActPath: deleteField(),
//         pdfActUpdatedAt: deleteField(),
//       });
//     } catch (e) {
//       console.error(e);
//       alert("Не вдалося видалити акт.");
//     }
//   };

//   useEffect(() => {
//     const unsubscribe = onSnapshot(collection(db, "users"), (snapshot) => {
//       const userList = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
//       setUsers(userList);
//     });
//     return () => unsubscribe();
//   }, []);

//   const handleDoubleClick = (user) => setEditedUser(user);

//   const handleInputChange = (e) => {
//     setEditedUser((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   const handleInputBlur = async (id) => {
//     try {
//       await updateDoc(doc(db, "users", id), editedUser);
//       setEditedUser(null);
//     } catch (error) {
//       console.log("Помилка при оновленні документа: ", error);
//     }
//   };

//   const filteredUsers = selectedCategory
//     ? users.filter((user) => user.category === selectedCategory)
//     : users;

//   const currentPaymentValue = (user, isEditing) =>
//     isEditing
//       ? editedUser?.paymentMethod ?? "card"
//       : user?.paymentMethod ?? "card";

//   return (
//     <div className={css.page}>
//       <div className={css.topbar}>
//         <h1 className={css.heading}>Користувачі</h1>
//         <div className={css.filters}>
//           <label className={css.filterLabel}>Категорія</label>
//           <select
//             className={css.select}
//             name="category"
//             value={selectedCategory}
//             onChange={(e) => setSelectedCategory(e.target.value)}
//           >
//             <option value="">Всі</option>

//             <option value='Член "Клубу Майстрів"'>Член "Клубу Майстрів"</option>
//             <option value="Бібліотекар">Бібліотекар</option>
//             <option value="Бізнес-партнер">Бізнес-партнер</option>
//             <option value="Майстер">Майстер</option>
//           </select>
//         </div>
//       </div>

//       <ul className={css.usersGrid}>
//         {filteredUsers.map((user) => {
//           const isEditing = editedUser && editedUser.id === user.id;
//           const payMethod = currentPaymentValue(user, isEditing);
//           const isBizInvoice =
//             user.category === "Бізнес-партнер" && payMethod === "invoice";

//           return (
//             <li key={user.id} className={css.card}>
//               <div className={css.cardHeader}>
//                 <div>
//                   <div className={css.cardTitle}>{user.displayName || "—"}</div>
//                   <div className={css.cardMeta}>
//                     {user.email || "—"} · {user.phone || "—"}
//                   </div>
//                 </div>
//                 {!isEditing ? (
//                   <button
//                     className={css.btnIcon}
//                     title="Редагувати рядок"
//                     onClick={() => handleDoubleClick(user)}
//                   >
//                     ✎
//                   </button>
//                 ) : (
//                   <button
//                     className={css.btnIcon}
//                     title="Зберегти"
//                     onClick={() => handleInputBlur(user.id)}
//                   >
//                     ✓
//                   </button>
//                 )}
//               </div>

//               <div className={css.fieldsGrid}>
//                 {/* Імʼя */}
//                 <div className={css.field}>
//                   <div className={css.label}>Імʼя</div>
//                   {isEditing ? (
//                     <input
//                       className={css.input}
//                       type="text"
//                       name="displayName"
//                       value={editedUser.displayName ?? ""}
//                       onChange={handleInputChange}
//                       onBlur={() => handleInputBlur(user.id)}
//                     />
//                   ) : (
//                     <div className={css.value}>{user.displayName || "—"}</div>
//                   )}
//                 </div>

//                 {/* Email */}
//                 <div className={css.field}>
//                   <div className={css.label}>Email</div>
//                   {isEditing ? (
//                     <input
//                       className={css.input}
//                       type="text"
//                       name="email"
//                       value={editedUser.email ?? ""}
//                       onChange={handleInputChange}
//                       onBlur={() => handleInputBlur(user.id)}
//                     />
//                   ) : (
//                     <div className={css.value}>{user.email || "—"}</div>
//                   )}
//                 </div>

//                 {/* Телефон */}
//                 <div className={css.field}>
//                   <div className={css.label}>Телефон</div>
//                   {isEditing ? (
//                     <input
//                       className={css.input}
//                       type="text"
//                       name="phone"
//                       value={editedUser.phone ?? ""}
//                       onChange={handleInputChange}
//                       onBlur={() => handleInputBlur(user.id)}
//                     />
//                   ) : (
//                     <div className={css.value}>{user.phone || "—"}</div>
//                   )}
//                 </div>

//                 {/* Роль */}
//                 <div className={css.field}>
//                   <div className={css.label}>Роль</div>
//                   {isEditing ? (
//                     <select
//                       className={css.select}
//                       name="category"
//                       value={editedUser.category ?? ""}
//                       onChange={handleInputChange}
//                       onBlur={() => handleInputBlur(user.id)}
//                     >
//                       <option value='Член "Клубу Майстрів"'>
//                         Член "Клубу Майстрів"
//                       </option>
//                       <option value="Бібліотекар">Бібліотекар</option>
//                       <option value="Бізнес-партнер">
//                         Бізнес-партнер
//                       </option>{" "}
//                       <option value="Майстер">Майстер</option>
//                     </select>
//                   ) : (
//                     <div className={css.pills}>
//                       <span className={css.pill}>{user.category || "—"}</span>
//                     </div>
//                   )}
//                 </div>

//                 {/* Знижка */}
//                 <div className={css.field}>
//                   <div className={css.label}>Знижка</div>
//                   {isEditing ? (
//                     <input
//                       className={css.input}
//                       type="text"
//                       name="discount"
//                       value={editedUser.discount ?? ""}
//                       onChange={handleInputChange}
//                       onBlur={() => handleInputBlur(user.id)}
//                     />
//                   ) : (
//                     <div className={css.value}>{user.discount || "—"}</div>
//                   )}
//                 </div>

//                 {/* Слони */}
//                 <div className={css.field}>
//                   <div className={css.label}>Слони</div>
//                   {isEditing ? (
//                     <input
//                       className={css.input}
//                       type="text"
//                       name="elefant"
//                       value={editedUser.elefant ?? ""}
//                       onChange={handleInputChange}
//                       onBlur={() => handleInputBlur(user.id)}
//                     />
//                   ) : (
//                     <div className={css.value}>{user.elefant || "—"}</div>
//                   )}
//                 </div>

//                 {/* Спосіб оплати */}
//                 <div className={css.field}>
//                   <div className={css.label}>Спосіб оплати</div>
//                   <select
//                     className={css.select}
//                     name="paymentMethod"
//                     value={payMethod}
//                     onChange={async (e) => {
//                       const val = e.target.value;
//                       if (isEditing) {
//                         setEditedUser((prev) => ({
//                           ...prev,
//                           paymentMethod: val,
//                         }));
//                       } else {
//                         await setPaymentMethod(user.id, val);
//                       }
//                     }}
//                     onBlur={async () => {
//                       if (isEditing) {
//                         await setPaymentMethod(
//                           user.id,
//                           editedUser.paymentMethod ?? "card"
//                         );
//                         setEditedUser(null);
//                       }
//                     }}
//                   >
//                     <option value="card">Карткою (за замовчуванням)</option>
//                     <option value="invoice">Рахунок ТОВ</option>
//                   </select>
//                 </div>
//               </div>

//               {/* ПАНЕЛЬ РАХУНКІВ — лише для бізнес-партнера з оплатою "invoice" */}
//               {isBizInvoice && (
//                 <div className={css.invoicesBlock}>
//                   <button
//                     className={css.btnCollapse}
//                     onClick={() =>
//                       setOpenInvoicesFor((id) =>
//                         id === user.id ? null : user.id
//                       )
//                     }
//                   >
//                     {openInvoicesFor === user.id
//                       ? "Сховати рахунки"
//                       : "Рахунки"}
//                   </button>

//                   {openInvoicesFor === user.id && (
//                     <div className={css.invoicesPanel}>
//                       <BusinessInvoicesAdmin uid={user.id} />
//                     </div>
//                   )}
//                 </div>
//               )}
//               {/* Акт звірки (1 шт на користувача) */}
//               <div className={css.field}>
//                 <div className={css.label}>Акт звірки (PDF)</div>

//                 {user.pdfAct ? (
//                   <div className={css.value}>
//                     <a
//                       href={user.pdfAct}
//                       target="_blank"
//                       rel="noreferrer noopener"
//                     >
//                       Відкрити акт
//                     </a>
//                     {" · "}
//                     <button
//                       type="button"
//                       className={css.btnLink}
//                       onClick={() => removePdfActForUser(user)}
//                     >
//                       Видалити
//                     </button>
//                   </div>
//                 ) : (
//                   <div className={css.value}>—</div>
//                 )}

//                 <label
//                   className={css.btnSoft}
//                   style={{
//                     marginTop: 8,
//                     display: "inline-block",
//                     cursor: "pointer",
//                   }}
//                 >
//                   {actUploadingFor === user.id
//                     ? "Завантаження..."
//                     : user.pdfAct
//                     ? "Замінити акт"
//                     : "Додати акт"}
//                   <input
//                     type="file"
//                     accept="application/pdf"
//                     style={{ display: "none" }}
//                     disabled={actUploadingFor === user.id}
//                     onChange={(e) => {
//                       const file = e.target.files?.[0];
//                       e.target.value = "";
//                       uploadPdfActForUser(user, file);
//                     }}
//                   />
//                 </label>
//               </div>
//             </li>
//           );
//         })}
//       </ul>
//     </div>
//   );
// };

// export default UserList;
import React, { useEffect, useMemo, useState } from "react";
import {
  collection,
  onSnapshot,
  updateDoc,
  doc,
  deleteField,
} from "firebase/firestore";
import { db } from "../../firebase";
import css from "./uthorListEditor.module.css";
import {
  getStorage,
  ref as sRef,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import BusinessInvoicesAdmin from "./users/BusinessInvoicesAdmin";

export const ROLES = {
  CLUB: 'Член "Клубу Майстрів"',
  LIBRARIAN: "Бібліотекар",
  BUSINESS: "Бізнес-партнер",
  MASTER: "Майстер",
};

const ROLE_OPTIONS = [
  ROLES.CLUB,
  ROLES.LIBRARIAN,
  ROLES.BUSINESS,
  ROLES.MASTER,
];

const DEFAULT_PAYMENT_METHOD = "card";
const MAX_FILE_SIZE = 20 * 1024 * 1024;

const ALLOWED_EXTENSIONS = [
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "csv",
  "txt",
  "rtf",
];

const ALLOWED_MIME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv",
  "text/plain",
  "application/rtf",
  "text/rtf",
  "application/octet-stream",
];

const FILE_ACCEPT =
  ".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.rtf,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,text/plain,application/rtf,text/rtf";

const getFileExtension = (filename = "") =>
  filename.split(".").pop()?.toLowerCase() || "";

const isAllowedFile = (file) => {
  if (!file) return false;

  const ext = getFileExtension(file.name);
  const mime = file.type || "";

  return ALLOWED_EXTENSIONS.includes(ext) || ALLOWED_MIME_TYPES.includes(mime);
};

const buildDraftFromUser = (user) => ({
  displayName: user?.displayName ?? "",
  email: user?.email ?? "",
  phone: user?.phone ?? "",
  category: user?.category ?? ROLES.CLUB,
  discount: user?.discount ?? "",
  elefant: user?.elefant ?? "",
  paymentMethod: user?.paymentMethod ?? DEFAULT_PAYMENT_METHOD,
});

const sanitizeUpdateData = (draft) => {
  const cleaned = {
    displayName: (draft?.displayName ?? "").trim(),
    email: (draft?.email ?? "").trim(),
    phone: (draft?.phone ?? "").trim(),
    category: draft?.category ?? ROLES.CLUB,
    discount: draft?.discount ?? "",
    elefant: draft?.elefant ?? "",
    paymentMethod: draft?.paymentMethod ?? DEFAULT_PAYMENT_METHOD,
  };

  Object.keys(cleaned).forEach((key) => {
    if (cleaned[key] === undefined) {
      delete cleaned[key];
    }
  });

  return cleaned;
};

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [editingUserId, setEditingUserId] = useState(null);
  const [draft, setDraft] = useState(buildDraftFromUser({}));
  const [openInvoicesFor, setOpenInvoicesFor] = useState(null);
  const [actUploadingFor, setActUploadingFor] = useState(null);
  const [savingUserId, setSavingUserId] = useState(null);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "users"), (snapshot) => {
      const userList = snapshot.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      setUsers(userList);
    });

    return () => unsubscribe();
  }, []);

  const filteredUsers = useMemo(() => {
    const base = selectedCategory
      ? users.filter((user) => user.category === selectedCategory)
      : users;

    return [...base].sort((a, b) => {
      const nameA = (a.displayName || "").toLowerCase();
      const nameB = (b.displayName || "").toLowerCase();
      return nameA.localeCompare(nameB, "uk");
    });
  }, [users, selectedCategory]);

  const startEditing = (user) => {
    setEditingUserId(user.id);
    setDraft(buildDraftFromUser(user));
  };

  const cancelEditing = () => {
    setEditingUserId(null);
    setDraft(buildDraftFromUser({}));
  };

  const handleDraftChange = (e) => {
    const { name, value } = e.target;
    setDraft((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const saveUser = async (userId) => {
    try {
      setSavingUserId(userId);
      const payload = sanitizeUpdateData(draft);

      await updateDoc(doc(db, "users", userId), payload);

      setEditingUserId(null);
      setDraft(buildDraftFromUser({}));
    } catch (error) {
      console.error("Помилка при оновленні користувача:", error);
      alert("Не вдалося зберегти зміни.");
    } finally {
      setSavingUserId(null);
    }
  };

  const updatePaymentMethodQuickly = async (userId, paymentMethod) => {
    try {
      await updateDoc(doc(db, "users", userId), {
        paymentMethod: paymentMethod || DEFAULT_PAYMENT_METHOD,
      });
    } catch (error) {
      console.error("Помилка при оновленні способу оплати:", error);
      alert("Не вдалося оновити спосіб оплати.");
    }
  };

  const uploadActFileForUser = async (user, file) => {
    if (!file) return;

    if (!isAllowedFile(file)) {
      alert("Дозволені формати: PDF, DOC, DOCX, XLS, XLSX, CSV, TXT, RTF.");
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      alert("Файл завеликий. Максимум 20MB.");
      return;
    }

    setActUploadingFor(user.id);

    try {
      const storage = getStorage();

      if (user.pdfActPath) {
        try {
          await deleteObject(sRef(storage, user.pdfActPath));
        } catch (e) {
          console.warn("Не вдалося видалити попередній файл:", e);
        }
      }

      const safeName = (file.name || "act_file").replace(/[^\w.\-]+/g, "_");
      const filePath = `users/${user.id}/actFiles/${Date.now()}_${safeName}`;
      const fileRef = sRef(storage, filePath);

      await uploadBytes(fileRef, file, {
        contentType: file.type || "application/octet-stream",
      });

      const downloadUrl = await getDownloadURL(fileRef);

      await updateDoc(doc(db, "users", user.id), {
        pdfAct: downloadUrl,
        pdfActPath: filePath,
        pdfActUpdatedAt: Date.now(),
        pdfActName: file.name || safeName,
        pdfActMimeType: file.type || "",
        pdfActExtension: getFileExtension(file.name),
        pdfActSize: file.size || 0,
      });
    } catch (error) {
      console.error("Помилка при завантаженні акта:", error);
      alert("Не вдалося завантажити файл акта.");
    } finally {
      setActUploadingFor(null);
    }
  };

  const removeActFileForUser = async (user) => {
    const confirmed = window.confirm("Видалити акт звірки?");
    if (!confirmed) return;

    try {
      const storage = getStorage();

      if (user.pdfActPath) {
        try {
          await deleteObject(sRef(storage, user.pdfActPath));
        } catch (e) {
          console.warn("Не вдалося видалити файл у Storage:", e);
        }
      }

      await updateDoc(doc(db, "users", user.id), {
        pdfAct: deleteField(),
        pdfActPath: deleteField(),
        pdfActUpdatedAt: deleteField(),
        pdfActName: deleteField(),
        pdfActMimeType: deleteField(),
        pdfActExtension: deleteField(),
        pdfActSize: deleteField(),
      });
    } catch (error) {
      console.error("Помилка при видаленні акта:", error);
      alert("Не вдалося видалити файл акта.");
    }
  };

  return (
    <div className={css.page}>
      <div className={css.topbar}>
        <h1 className={css.heading}>Користувачі</h1>

        <div className={css.filters}>
          <label className={css.filterLabel}>Категорія</label>
          <select
            className={css.select}
            name="category"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <option value="">Всі</option>
            {ROLE_OPTIONS.map((role) => (
              <option key={role} value={role}>
                {role}
              </option>
            ))}
          </select>
        </div>
      </div>

      <ul className={css.usersGrid}>
        {filteredUsers.map((user) => {
          const isEditing = editingUserId === user.id;
          const payMethod = isEditing
            ? (draft.paymentMethod ?? DEFAULT_PAYMENT_METHOD)
            : (user.paymentMethod ?? DEFAULT_PAYMENT_METHOD);

          const isBusinessPartner = user.category === ROLES.BUSINESS;
          const isBizInvoice = isBusinessPartner && payMethod === "invoice";

          return (
            <li key={user.id} className={css.card}>
              <div className={css.cardHeader}>
                <div>
                  <div className={css.cardTitle}>{user.displayName || "—"}</div>
                  <div className={css.cardMeta}>
                    {user.email || "—"} · {user.phone || "—"}
                  </div>
                </div>

                {!isEditing ? (
                  <button
                    type="button"
                    className={css.btnIcon}
                    title="Редагувати"
                    onClick={() => startEditing(user)}
                  >
                    ✎
                  </button>
                ) : (
                  <div style={{ display: "flex", gap: 8 }}>
                    <button
                      type="button"
                      className={css.btnIcon}
                      title="Зберегти"
                      disabled={savingUserId === user.id}
                      onClick={() => saveUser(user.id)}
                    >
                      {savingUserId === user.id ? "..." : "✓"}
                    </button>
                    <button
                      type="button"
                      className={css.btnIcon}
                      title="Скасувати"
                      onClick={cancelEditing}
                    >
                      ✕
                    </button>
                  </div>
                )}
              </div>

              <div className={css.fieldsGrid}>
                <div className={css.field}>
                  <div className={css.label}>Імʼя</div>
                  {isEditing ? (
                    <input
                      className={css.input}
                      type="text"
                      name="displayName"
                      value={draft.displayName}
                      onChange={handleDraftChange}
                    />
                  ) : (
                    <div className={css.value}>{user.displayName || "—"}</div>
                  )}
                </div>

                <div className={css.field}>
                  <div className={css.label}>Email</div>
                  {isEditing ? (
                    <input
                      className={css.input}
                      type="text"
                      name="email"
                      value={draft.email}
                      onChange={handleDraftChange}
                    />
                  ) : (
                    <div className={css.value}>{user.email || "—"}</div>
                  )}
                </div>

                <div className={css.field}>
                  <div className={css.label}>Телефон</div>
                  {isEditing ? (
                    <input
                      className={css.input}
                      type="text"
                      name="phone"
                      value={draft.phone}
                      onChange={handleDraftChange}
                    />
                  ) : (
                    <div className={css.value}>{user.phone || "—"}</div>
                  )}
                </div>

                <div className={css.field}>
                  <div className={css.label}>Роль</div>
                  {isEditing ? (
                    <select
                      className={css.select}
                      name="category"
                      value={draft.category}
                      onChange={handleDraftChange}
                    >
                      {ROLE_OPTIONS.map((role) => (
                        <option key={role} value={role}>
                          {role}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <div className={css.pills}>
                      <span className={css.pill}>{user.category || "—"}</span>
                    </div>
                  )}
                </div>

                <div className={css.field}>
                  <div className={css.label}>Знижка</div>
                  {isEditing ? (
                    <input
                      className={css.input}
                      type="text"
                      name="discount"
                      value={draft.discount}
                      onChange={handleDraftChange}
                    />
                  ) : (
                    <div className={css.value}>{user.discount || "—"}</div>
                  )}
                </div>

                <div className={css.field}>
                  <div className={css.label}>Слони</div>
                  {isEditing ? (
                    <input
                      className={css.input}
                      type="text"
                      name="elefant"
                      value={draft.elefant}
                      onChange={handleDraftChange}
                    />
                  ) : (
                    <div className={css.value}>{user.elefant || "—"}</div>
                  )}
                </div>

                <div className={css.field}>
                  <div className={css.label}>Спосіб оплати</div>
                  {isEditing ? (
                    <select
                      className={css.select}
                      name="paymentMethod"
                      value={draft.paymentMethod}
                      onChange={handleDraftChange}
                    >
                      <option value="card">Карткою (за замовчуванням)</option>
                      <option value="invoice">Рахунок ТОВ</option>
                    </select>
                  ) : (
                    <select
                      className={css.select}
                      name="paymentMethod"
                      value={payMethod}
                      onChange={(e) =>
                        updatePaymentMethodQuickly(user.id, e.target.value)
                      }
                    >
                      <option value="card">Карткою (за замовчуванням)</option>
                      <option value="invoice">Рахунок ТОВ</option>
                    </select>
                  )}
                </div>
              </div>

              {isBizInvoice && (
                <div className={css.invoicesBlock}>
                  <button
                    type="button"
                    className={css.btnCollapse}
                    onClick={() =>
                      setOpenInvoicesFor((prev) =>
                        prev === user.id ? null : user.id,
                      )
                    }
                  >
                    {openInvoicesFor === user.id
                      ? "Сховати рахунки"
                      : "Рахунки"}
                  </button>

                  {openInvoicesFor === user.id && (
                    <div className={css.invoicesPanel}>
                      <BusinessInvoicesAdmin uid={user.id} />
                    </div>
                  )}
                </div>
              )}

              {isBusinessPartner && (
                <div className={css.field}>
                  <div className={css.label}>Акт звірки</div>

                  {user.pdfAct ? (
                    <div className={css.value}>
                      <a
                        href={user.pdfAct}
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        {user.pdfActName
                          ? `Відкрити: ${user.pdfActName}`
                          : "Відкрити файл"}
                      </a>
                      {" · "}
                      <button
                        type="button"
                        className={css.btnLink}
                        onClick={() => removeActFileForUser(user)}
                      >
                        Видалити
                      </button>
                    </div>
                  ) : (
                    <div className={css.value}>—</div>
                  )}

                  <label
                    className={css.btnSoft}
                    style={{
                      marginTop: 8,
                      display: "inline-block",
                      cursor: "pointer",
                    }}
                  >
                    {actUploadingFor === user.id
                      ? "Завантаження..."
                      : user.pdfAct
                        ? "Замінити файл"
                        : "Додати файл"}

                    <input
                      type="file"
                      accept={FILE_ACCEPT}
                      style={{ display: "none" }}
                      disabled={actUploadingFor === user.id}
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        e.target.value = "";
                        uploadActFileForUser(user, file);
                      }}
                    />
                  </label>

                  <div
                    className={css.value}
                    style={{ marginTop: 6, fontSize: 12, opacity: 0.8 }}
                  >
                    Дозволено: PDF, DOC, DOCX, XLS, XLSX, CSV, TXT, RTF
                  </div>
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default UserList;
